const PrerenderService = {
  managedByRoute: false,

  markNotReady() {
    this.managedByRoute = true;
    window.prerenderReady = false;
  },

  markReady() {
    window.prerenderReady = true;
  },

  markReadyIfNotManaged() {
    if (!this.managedByRoute) {
      window.prerenderReady = true;
    }
  },
};

export default PrerenderService;
